import { render, staticRenderFns } from "./FAD.vue?vue&type=template&id=546fab68"
import script from "./FAD.vue?vue&type=script&lang=js"
export * from "./FAD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546fab68')) {
      api.createRecord('546fab68', component.options)
    } else {
      api.reload('546fab68', component.options)
    }
    module.hot.accept("./FAD.vue?vue&type=template&id=546fab68", function () {
      api.rerender('546fab68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/FAD.vue"
export default component.exports